import * as Effect from "effect-app/Effect"
import { NonEmptyString255, NonEmptyString2k, StringId } from "effect-app/Schema"
import * as S from "effect-app/Schema"

export const SKU = NonEmptyString255
export type SKU = NonEmptyString255

export const OptionGroupId = StringId
export type OptionGroupId = StringId

// null = not (yet) linked to a CSV price import row
export const PriceId = S.NullOr(NonEmptyString255).pipe(
  S.withDecodingDefault(Effect.succeed(null)),
  S.withConstructorDefault(Effect.succeed(null))
)
export type PriceId = typeof PriceId.Type

// Backoffice-only context for operators (why an option or condition is set up the
// way it is). Never part of what customers see; the public option models omit it.
export const OperatorNote = S.NullOr(NonEmptyString2k).pipe(
  S.withDecodingDefault(Effect.succeed(null)),
  S.withConstructorDefault(Effect.succeed(null))
)
export type OperatorNote = typeof OperatorNote.Type

// The note in update payloads: required, so a sender that leaves it out gets a
// decode error instead of silently wiping the stored note.
export const OperatorNoteInput = S.NullOr(NonEmptyString2k)
